
import { defineComponent, computed } from 'vue'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'CardProfile',
  setup() {
    const { currentTheme, currentMode, isLight } = useTheme()

    const cardClasses = computed(() => {
      const shadow = isLight.value ? 'shadow-lg' : ``

      return [currentTheme.value.bg.card, shadow]
    })

    return {
      currentTheme,
      cardClasses,
      currentMode,
    }
  },
})
